import {
    ready,
    env,
    runtime,
    biz
} from 'dingtalk-jsapi';
import { ENV_ENUM } from 'dingtalk-jsapi/lib/sdk';
import { race } from './dingtalk.util';

// FIXME src\modules\3rd-party-integration\utils\env.ts has another isDTRuntime
export const isDTRuntime = env.platform !== ENV_ENUM.notInDingTalk;

export function dingtalkSDKReady() {
    return race(new Promise<null>((resolve) => {
        ready(() => resolve(null))
    }))
}

export async function getAuthCodeByCorpId(corpId: string) {
    return runtime.permission.requestAuthCode({ corpId });
}

export async function openSlidePanel(url: string) {
    return biz.util.openSlidePanel({
        url,
        title: '福昕PDF高级编辑器'
    })
}

export async function openLink(url: string) {
    return biz.util.openLink({ url });
}
